import React, { useEffect, useState } from 'react'
import Home from './home/Home'
import Login from './pages/Login'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { HashRouter, Route, Switch, useHistory } from 'react-router-dom';

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import RessetPassword from './pages/RessetPassword';
import RecuperarPassword from './pages/RecuperarPassword';
// import { Service } from './service/Service';
import NotFound from './pages/404';

const App = () => {
    // const [cargar, setCargar] = useState(false)
    const [logueado, setLogueado] = useState(false)
    const [scale, setScale] = useState(15);
    const [expiro, setExpiro] = useState(false)

    //--> Redimensionar
    useEffect(() => { document.documentElement.style.fontSize = scale + 'px'; }, [scale])

    //--------------------| Verificar inicio de sesion |--------------------
    useEffect(() => {
        const informacionSesion = localStorage.getItem('tokenAdmin'); // Busca el valor creado
        if (informacionSesion === '1') {                        // Comprobar valor de inicio de sesion
            setLogueado(true);                                  // Inicio de sesion
        }
    }, []);                                                     // Se ejecuta al cargar la pagina

    let history = useHistory();
    useEffect(() => {
        const setExpirationTime = () => {
            setTimeout(() => {
                localStorage.removeItem('tokenAdmin')        // Eliminar valor para terminar sesion
                setLogueado(false)
                history.push("/")
                console.log("Termino la sesion")
                setExpiro(true)
            }, 172799995);
        }
        if (logueado === true) {
            setExpirationTime()
        }
    }, [logueado])

    //--> Revizar si hay token
    useEffect(() => { if (localStorage.getItem('tokenAdmin')) { setLogueado(true) } }, [])

    useEffect(() => {
        // Escuchar el evento "storage" en la pestaña 1
        const handleStorageChange = (event) => {
            if (event.key === 'tokenAdmin' && event.newValue === null) {
                // El token ha sido eliminado en otra pestaña, ejecutar acciones de cierre de sesión en esta pestaña
                // setToken('');
                setLogueado(false)
                console.log('La sesión ha sido cerrada en otra pestaña.');
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    //--> Botón de expiro
    const botonExpiro = (<><Button label="Aceptar" icon="pi pi-check" onClick={() => setExpiro(false)} /></>)

    //--------------------| Valor que regresara |--------------------
    return (
        <>
            {!logueado && (
                <>
                    <HashRouter>
                        <Switch>
                            <Route path="/recuperarPassword" component={RessetPassword} />
                            <Route path="/setPassword" component={RecuperarPassword} />
                            <Route exact path="/">  <Login setLogueado={setLogueado} /> </Route>
                            <Route component={NotFound} />
                        </Switch>
                    </HashRouter>
                </>
            )}

            {logueado && <Home setLogueado={setLogueado} />}
            <Dialog
                header="Sesión Terminada." visible={expiro} style={{ width: '50vw' }}
                onHide={() => setExpiro(false)} footer={botonExpiro}>
                <p className="text-center">Su tiempo de sesión en el sistema ha finalizado.</p>
                <p className='text-center'>Por favor vuelva iniciar sesión.</p>
            </Dialog>
        </>
    )
}

export default App
